module.exports = __webpack_public_path__ + "img/2162459.ed1fdb0b.jpg";